"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSelectedPlanVariant = exports.selectSelectedPlanId = exports.selectSelectedPlan = exports.selectSelectedHandsetVariant = exports.selectSelectedHandsetId = exports.selectSelectedHandset = exports.selectSelectedBusinessSolutionVariant = exports.selectSelectedBusinessSolutionId = exports.selectSelectedBusinessSolution = exports.selectSelectedBroadbandVariant = exports.selectSelectedBroadbandId = exports.selectSelectedBroadband = exports.selectRecommendationsSteps = exports.selectRecommendationRawData = exports.selectRecommendationProductOfferings = exports.selectRecommendationPlans = exports.selectRecommendationHandsets = exports.selectRecommendationCurrentStep = exports.selectRecommendationBusinessSolutions = exports.selectRecommendationBroadbands = exports.selectRating = exports.selectProductsByType = exports.selectPricesCosts = exports.selectPlan = exports.selectIsRecommendationReopen = exports.selectIsRecommendationFetched = exports.selectIsAddonSelected = exports.selectHandset = exports.selectChangeAdditionalPlansType = exports.selectBusinessSolution = exports.selectBroadband = exports.selectAreRecommendationSpecsVisible = exports.selectAdditionalPlans = void 0;
var _constants = require("../../utils/constants");
var _utils = require("../../utils/utils");
var _questionnaireSelectors = require("../questionnaire/questionnaireSelectors");
const selectRecommendationRawData = instanceId => state => {
  return state.drools[instanceId].recommendation.recommendationRawData;
};
exports.selectRecommendationRawData = selectRecommendationRawData;
const selectAreRecommendationSpecsVisible = instanceId => state => state.drools[instanceId].recommendation.areRecommendationSpecsVisible;
exports.selectAreRecommendationSpecsVisible = selectAreRecommendationSpecsVisible;
const selectIsRecommendationFetched = instanceId => state => state.drools[instanceId].recommendation.isRecommendationFetched;
exports.selectIsRecommendationFetched = selectIsRecommendationFetched;
const selectProductsByType = type => instanceId => {
  switch (type) {
    case _constants.PRODUCT_TYPES.HANDSET:
      return selectRecommendationHandsets(instanceId);
    case _constants.PRODUCT_TYPES.PLAN:
      return selectRecommendationPlans(instanceId);
    case _constants.PRODUCT_TYPES.BROADBAND:
      return selectRecommendationBroadbands(instanceId);
    case _constants.PRODUCT_TYPES.BUSINESS_SOLUTION:
      return selectRecommendationBusinessSolutions(instanceId);
    default:
      return selectRecommendationHandsets(instanceId);
  }
};

/**
 * Handset selectors
 */
exports.selectProductsByType = selectProductsByType;
const selectRecommendationHandsets = instanceId => state => {
  return state.drools[instanceId].recommendation.handsets;
};
exports.selectRecommendationHandsets = selectRecommendationHandsets;
const selectHandset = (state, tier, instanceId) => {
  const handsets = selectRecommendationHandsets(instanceId)(state);
  return handsets.find(handset => handset.tier === tier);
};
exports.selectHandset = selectHandset;
const selectSelectedHandset = instanceId => state => {
  const handsets = selectRecommendationHandsets(instanceId)(state);
  const selectedHandsetId = selectSelectedHandsetId(instanceId)(state);
  return handsets.find(handset => handset.productId === selectedHandsetId);
};
exports.selectSelectedHandset = selectSelectedHandset;
const selectSelectedHandsetVariant = instanceId => state => {
  var _selectSelectedHandse;
  return (_selectSelectedHandse = selectSelectedHandset(instanceId)(state)) === null || _selectSelectedHandse === void 0 ? void 0 : _selectSelectedHandse.selectedVariant;
};
exports.selectSelectedHandsetVariant = selectSelectedHandsetVariant;
const selectSelectedHandsetId = instanceId => state => {
  const recommendedHandset = selectHandset(state, _constants.RECOMMENDATION_TIER.RECOMMENDED, instanceId);
  return state.drools[instanceId].recommendation.selectedHandsetId || (recommendedHandset === null || recommendedHandset === void 0 ? void 0 : recommendedHandset.productId);
};

/**
 * Plan selectors
 */
exports.selectSelectedHandsetId = selectSelectedHandsetId;
const selectRecommendationPlans = instanceId => state => {
  return state.drools[instanceId].recommendation.plans;
};
exports.selectRecommendationPlans = selectRecommendationPlans;
const selectPlan = (state, tier, instanceId) => {
  var _clone$recommendation, _plans$find;
  const plans = selectRecommendationPlans(instanceId)(state);
  const fixedOfferings = (_clone$recommendation = (0, _utils.clone)((0, _questionnaireSelectors.selectMetadata)(instanceId)(state)).recommendationCategories) === null || _clone$recommendation === void 0 ? void 0 : _clone$recommendation[0].fixedOfferings;
  return (_plans$find = plans.find(plan => plan.tier === tier && (fixedOfferings === null || fixedOfferings === void 0 ? void 0 : fixedOfferings.find(el => el.id === plan.productId)))) !== null && _plans$find !== void 0 ? _plans$find : plans.find(plan => plan.tier === tier);
};
exports.selectPlan = selectPlan;
const selectSelectedPlan = instanceId => state => {
  var _clone$recommendation2, _selectedPlan;
  const plans = selectRecommendationPlans(instanceId)(state);
  const selectedPlanId = selectSelectedPlanId(instanceId)(state);
  let selectedPlan = plans.find(plan => plan.productId === selectedPlanId);
  const fixedOfferings = (_clone$recommendation2 = (0, _utils.clone)((0, _questionnaireSelectors.selectMetadata)(instanceId)(state)).recommendationCategories) === null || _clone$recommendation2 === void 0 ? void 0 : _clone$recommendation2[0].fixedOfferings;
  if (fixedOfferings && ((_selectedPlan = selectedPlan) === null || _selectedPlan === void 0 ? void 0 : _selectedPlan.tier) === 'recommended') {
    selectedPlan = selectPlan(state, _constants.RECOMMENDATION_TIER.RECOMMENDED, instanceId);
  }
  return selectedPlan;
};
exports.selectSelectedPlan = selectSelectedPlan;
const selectSelectedPlanVariant = instanceId => state => {
  var _selectSelectedPlan;
  return (_selectSelectedPlan = selectSelectedPlan(instanceId)(state)) === null || _selectSelectedPlan === void 0 ? void 0 : _selectSelectedPlan.selectedVariant;
};
exports.selectSelectedPlanVariant = selectSelectedPlanVariant;
const selectSelectedPlanId = instanceId => state => {
  const recommendedPlan = selectPlan(state, _constants.RECOMMENDATION_TIER.RECOMMENDED, instanceId);
  return state.drools[instanceId].recommendation.selectedPlanId || (recommendedPlan === null || recommendedPlan === void 0 ? void 0 : recommendedPlan.productId);
};
exports.selectSelectedPlanId = selectSelectedPlanId;
const selectRecommendationsSteps = instanceId => state => {
  return state.drools[instanceId].recommendation.steps;
};
exports.selectRecommendationsSteps = selectRecommendationsSteps;
const selectRecommendationCurrentStep = instanceId => state => {
  return state.drools[instanceId].recommendation.currentStep;
};
exports.selectRecommendationCurrentStep = selectRecommendationCurrentStep;
const selectAdditionalPlans = instanceId => state => {
  return state.drools[instanceId].recommendation.additionalPlans;
};
exports.selectAdditionalPlans = selectAdditionalPlans;
const selectChangeAdditionalPlansType = instanceId => state => {
  return state.drools[instanceId].recommendation.type;
};
exports.selectChangeAdditionalPlansType = selectChangeAdditionalPlansType;
const selectPricesCosts = instanceId => state => {
  return state.drools[instanceId].recommendation.pricesCosts;
};

/**
 * Broadband selectors
 */
exports.selectPricesCosts = selectPricesCosts;
const selectRecommendationBroadbands = instanceId => state => {
  return state.drools[instanceId].recommendation.broadbands;
};
exports.selectRecommendationBroadbands = selectRecommendationBroadbands;
const selectBroadband = (state, tier, instanceId) => {
  const broadbands = selectRecommendationBroadbands(instanceId)(state);
  return broadbands.find(broadbands => broadbands.tier === tier);
};
exports.selectBroadband = selectBroadband;
const selectSelectedBroadband = instanceId => state => {
  const broadbands = selectRecommendationBroadbands(instanceId)(state);
  const selectedBroadbandId = selectSelectedBroadbandId(instanceId)(state);
  return broadbands.find(broadband => broadband.productId === selectedBroadbandId);
};
exports.selectSelectedBroadband = selectSelectedBroadband;
const selectSelectedBroadbandVariant = instanceId => state => {
  var _selectSelectedBroadb;
  return (_selectSelectedBroadb = selectSelectedBroadband(instanceId)(state)) === null || _selectSelectedBroadb === void 0 ? void 0 : _selectSelectedBroadb.selectedVariant;
};
exports.selectSelectedBroadbandVariant = selectSelectedBroadbandVariant;
const selectSelectedBroadbandId = instanceId => state => {
  const recommendedBroadband = selectBroadband(state, _constants.RECOMMENDATION_TIER.RECOMMENDED, instanceId);
  return state.drools[instanceId].recommendation.selectedBroadbandId || (recommendedBroadband === null || recommendedBroadband === void 0 ? void 0 : recommendedBroadband.productId);
};
/**
 * Business solution selectors
 */
exports.selectSelectedBroadbandId = selectSelectedBroadbandId;
const selectRecommendationBusinessSolutions = instanceId => state => {
  return state.drools[instanceId].recommendation.businessSolutions;
};
exports.selectRecommendationBusinessSolutions = selectRecommendationBusinessSolutions;
const selectBusinessSolution = (state, tier, instanceId) => {
  const businessSolutions = selectRecommendationBusinessSolutions(instanceId)(state);
  return businessSolutions.find(businessSolutions => businessSolutions.tier === tier);
};
exports.selectBusinessSolution = selectBusinessSolution;
const selectSelectedBusinessSolution = instanceId => state => {
  const businessSolutions = selectRecommendationBusinessSolutions(instanceId)(state);
  const selectedBusinessSolutionId = selectSelectedBusinessSolutionId(instanceId)(state);
  return businessSolutions.find(businessSolution => businessSolution.productId === selectedBusinessSolutionId);
};
exports.selectSelectedBusinessSolution = selectSelectedBusinessSolution;
const selectSelectedBusinessSolutionVariant = instanceId => state => {
  var _selectSelectedBusine;
  return (_selectSelectedBusine = selectSelectedBusinessSolution(instanceId)(state)) === null || _selectSelectedBusine === void 0 ? void 0 : _selectSelectedBusine.selectedVariant;
};
exports.selectSelectedBusinessSolutionVariant = selectSelectedBusinessSolutionVariant;
const selectSelectedBusinessSolutionId = instanceId => state => {
  const recommendedBusinessSolution = selectBusinessSolution(state, _constants.RECOMMENDATION_TIER.RECOMMENDED, instanceId);
  return state.drools[instanceId].recommendation.selectedBusinessSolutionsId || (recommendedBusinessSolution === null || recommendedBusinessSolution === void 0 ? void 0 : recommendedBusinessSolution.productId);
};
exports.selectSelectedBusinessSolutionId = selectSelectedBusinessSolutionId;
const selectIsAddonSelected = instanceId => state => {
  return state.drools[instanceId].recommendation.isAddonSelected;
};

/**
 * Relationship products selectors
 */
exports.selectIsAddonSelected = selectIsAddonSelected;
const selectRecommendationProductOfferings = instanceId => state => {
  return state.drools[instanceId].productCatalog.productRelationshipOffering;
};
exports.selectRecommendationProductOfferings = selectRecommendationProductOfferings;
const selectRating = instanceId => state => {
  return state.drools[instanceId].recommendation.ratingData;
};
exports.selectRating = selectRating;
const selectIsRecommendationReopen = instanceId => state => {
  return state.drools[instanceId].recommendation.isRecommendationReopen;
};
exports.selectIsRecommendationReopen = selectIsRecommendationReopen;